import { useEffect, useRef } from 'react'

export interface IProgressBarProps {
  percent?: number
  toFixed?: number
}

export const ProgressBar = ({ percent = 0, toFixed = 0 }: IProgressBarProps) => {
  const ref = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (ref?.current) {
      if (percent > 0) {
        ref.current.style.width = `${percent > 15 ? percent : 15}%`
      } else {
        ref.current.style.width = '0%'
      }
    }
  }, [percent])

  return (
    <div className={'flex items-center gap-[9px] overflow-hidden'}>
      <div className='w-[50px] whitespace-nowrap text-right text-[15px] text-focus-500'>
        {`${parseFloat(percent.toFixed(toFixed)) % 1 === 0 ? Math.floor(percent) : percent.toFixed(toFixed)}%`}
      </div>
      <span className='flex h-[6px] w-full w-[75px] rounded-[12px] bg-focus-600/[0.07]'>
        <span ref={ref} className='h-full rounded-[12px] bg-default'></span>
      </span>
    </div>
  )
}
